import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PlaceCard } from "@/components/PlaceCard";

export default function Saved() {
  const { user } = useAuth();
  const [places, setPlaces] = useState([]);

  useEffect(() => {
    if (user && user.saved_places?.length) {
      api.get("/places").then((r) => setPlaces(r.data.filter((p) => user.saved_places.includes(p.id))));
    } else {
      setPlaces([]);
    }
  }, [user]);

  if (user === false) {
    return (
      <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 text-center">
        <Heart size={40} className="mb-3 text-primary" />
        <h1 className="font-serif text-3xl font-bold">Save your favorites</h1>
        <p className="mt-2 text-muted-foreground">Sign in to keep track of the places you love.</p>
        <Link to="/auth" className="mt-5 rounded-full bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground">Sign in</Link>
      </div>
    );
  }

  return (
    <div className="px-4 py-6 md:px-8">
      <h1 className="mb-6 flex items-center gap-2 font-serif text-3xl font-bold md:text-4xl">
        <Heart className="fill-primary text-primary" /> Saved Places
      </h1>
      {places.length ? (
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {places.map((p, i) => <PlaceCard key={p.id} place={p} index={i} />)}
        </div>
      ) : (
        <div className="py-20 text-center text-muted-foreground" data-testid="saved-empty">
          No saved places yet. Tap the ♥ on any place to save it.
        </div>
      )}
    </div>
  );
}
